/**
 * Utility functions for proper Belarusian word declensions
 */

/**
 * Get correct declension for "лакацыя" (location)
 * 1 лакацыя, 2-4 лакацыі, 5+ лакацый
 */
export const getLocationWord = (count: number): string => {
  const lastDigit = count % 10;
  const lastTwoDigits = count % 100;
  
  // Special cases for 11-14
  if (lastTwoDigits >= 11 && lastTwoDigits <= 14) {
    return 'лакацый';
  }
  
  if (lastDigit === 1) {
    return 'лакацыя';
  } else if (lastDigit >= 2 && lastDigit <= 4) {
    return 'лакацыі';
  } else {
    return 'лакацый';
  }
};

/**
 * Get correct declension for "абраная лакацыя" (favorite location)
 * 1 абраная лакацыя, 2-4 абраныя лакацыі, 5+ абраных лакацый
 */
export const getFavoriteLocationWord = (count: number): string => {
  const lastDigit = count % 10;
  const lastTwoDigits = count % 100;
  
  // Special cases for 11-14
  if (lastTwoDigits >= 11 && lastTwoDigits <= 14) {
    return 'абраных лакацый';
  }
  
  if (lastDigit === 1) {
    return 'абраная лакацыя';
  } else if (lastDigit >= 2 && lastDigit <= 4) {
    return 'абраныя лакацыі';
  } else {
    return 'абраных лакацый';
  }
};

/**
 * Get correct declension for "наведаная лакацыя" (visited location)
 * 1 наведаная лакацыя, 2-4 наведаныя лакацыі, 5+ наведаных лакацый
 */
export const getVisitedLocationWord = (count: number): string => {
  const lastDigit = count % 10;
  const lastTwoDigits = count % 100;
  
  // Special cases for 11-14
  if (lastTwoDigits >= 11 && lastTwoDigits <= 14) {
    return 'наведаных лакацый';
  }
  
  if (lastDigit === 1) {
    return 'наведаная лакацыя';
  } else if (lastDigit >= 2 && lastDigit <= 4) {
    return 'наведаныя лакацыі';
  } else {
    return 'наведаных лакацый';
  }
};

/**
 * Get correct verb form for "наведаць" (to visit)
 * 1 наведаў, 2+ наведалі
 */
export const getVisitedVerb = (count: number): string => {
  if (count === 1) {
    return 'наведаў';
  } else {
    return 'наведалі';
  }
};

/**
 * Get correct verb form for "быць" (to be)
 * 1 быў, 2+ былі
 */
export const getWasVerb = (count: number): string => {
  if (count === 1) {
    return 'быў';
  } else {
    return 'былі';
  }
};

/**
 * Get correct declension for "чалавек" (person)
 * 1 чалавек, 2-4 чалавекі, 5+ чалавек
 */
export const getPersonWord = (count: number): string => {
  const lastDigit = count % 10;
  const lastTwoDigits = count % 100;
  
  // Special cases for 11-14
  if (lastTwoDigits >= 11 && lastTwoDigits <= 14) {
    return 'чалавек';
  }
  
  if (lastDigit === 1) {
    return 'чалавек';
  } else if (lastDigit >= 2 && lastDigit <= 4) {
    return 'чалавекі';
  } else {
    return 'чалавек';
  }
};

/**
 * Get correct declension for "спадабалася" (liked)
 * 1 спадабалася, 2+ спадабаліся
 */
export const getLikedVerb = (count: number): string => {
  if (count === 1) {
    return 'спадабалася';
  } else {
    return 'спадабаліся';
  }
};

/**
 * Get correct declension for "не спадабалася" (disliked)
 * 1 не спадабалася, 2+ не спадабаліся
 */
export const getDislikedVerb = (count: number): string => {
  if (count === 1) {
    return 'не спадабалася';
  } else {
    return 'не спадабаліся';
  }
};

/**
 * Get correct declension for "задаволены" (satisfied)
 * Always use "задаволеныя" for percentage
 */
export const getSatisfiedWord = (): string => {
  return 'задаволеныя';
};